import moment from "moment";

//Builds R1S objects from Parkpass objects consisting of flattened user input
export default class ParkpassToR1SPassConverter {
  convert(pass) {
    //Parkpass pass object is flat key value pairs.  Need to form R1S structure

    //Initialze with base level fields
    let priceCalc = parseInt(pass.price) / 100000;
    let r1sPass = {
      siteId: pass.siteId,
      sku: pass.sku,
      description: pass.description,
      price: priceCalc,
      holder_info: {
        email: pass.visitoremail,
        first_name: pass.firstname,
        last_name: pass.lastname
      },
      pass_type_id: pass.passtype,
      features: {
        "start-date": moment
          .utc(pass["start-date"], "MM/DD/YYYY")
          .format("YYYY-MM-DD")
      }
    };

    //Add vehicle fields
    if (pass.vehicle) {
      r1sPass.features["equipment-info"] = {
        vehicle: {
          type: pass.vehicle
        }
      };

      if (pass.licenseplate) {
        r1sPass.features["equipment-info"].vehicle.fields = {
          license: pass.licenseplate
        };
      }
    }

    //Add watercraft fields
    if (pass.watercraft) {
      r1sPass.features["equipment-info"] = {
        watercraft: {
          type: pass.watercraft
        }
      };

      if (pass.licenseplate) {
        r1sPass.features["equipment-info"].watercraft.fields = {
          license: pass.licenseplate
        };
      }
    }

    //Add attendee-info fields
    if ((pass.adults || pass.children) && !pass.days && !pass.nights) {
      r1sPass.features["attendee-info"] = {
        adults: parseInt(pass.adults),
        children: parseInt(pass.children)
      };
    }

    //Day/Night Fields for Havasu
    if (pass.days || pass.nights) {
      r1sPass.features["day-segment"] = {
        groups: {
          adults: pass.adults
        },
        segments: {}
      };
      pass.days.forEach(day => {
        r1sPass.features["day-segment"].segments[
          moment(day, "MM/DD/YYYY").format("YYYY-MM-DD")
        ] = {
          day: true
        };
      });
      pass.nights.forEach(night => {
        if (
          !r1sPass.features["day-segment"].segments[
            moment(night, "MM/DD/YYYY").format("YYYY-MM-DD")
          ]
        ) {
          r1sPass.features["day-segment"].segments[
            moment(night, "MM/DD/YYYY").format("YYYY-MM-DD")
          ] = {
            night: true
          };
        } else {
          r1sPass.features["day-segment"].segments[
            moment(night, "MM/DD/YYYY").format("YYYY-MM-DD")
          ].night = true;
        }
      });

      //r1sPass.features.discount = "123456";
    }
    //R1S is changing to require Accepted on Need to Know and not Refund Policys
    if (pass.refundpolicy == true) {
      r1sPass.features.accepted = {};
      r1sPass.features.accepted["refund-policy"] = true;
    }
    if (pass.accepted == true) {
      r1sPass.features.accepted = {};
      r1sPass.features.accepted["need_to_know"] = true;
    }

    if (pass.discountPassNumber) {
      r1sPass.features.discount = { pass_number: pass.discountPassNumber };
    } else {
      r1sPass.features.discount = { pass_number: "" };
    }

    let optionKeys = Object.keys(pass).filter(item => {
      //Option keys are previxed with "option:".  Exclude the display value items.
      return item.includes("option:") && !item.endsWith("DisplayValue");
    });

    if (optionKeys.length > 0) {
      r1sPass.features["option-select"] = [];
      optionKeys.forEach(optionKey => {
        let option = {
          type: optionKey.replace("option:", ""),
          value: pass[optionKey]
        };
        r1sPass.features["option-select"].push(option);
      });
    }

    return r1sPass;
  }
}
